import Service from './Service'
import moment from 'moment'

class RegionCustomerGroupPriceLists extends Service {
  /** @type {StoreRegions} */
  storeRegions

  /** @type {PriceLists} */
  priceLists

  /** @type {Array} */
  cachedBasePriceLists

  /** @type {moment} */
  basePriceListCacheTimes

  constructor (connection, storeRegions, priceLists) {
    super(connection)
    this.storeRegions = storeRegions
    this.priceLists = priceLists
    this.cachedBasePriceLists = []
    this.basePriceListCacheTimes = []
  }

  getBasePriceList (regionId, customerGroupId, startDate, endDate) {
    if (this.cachedBasePriceLists[regionId] &&
      this.cachedBasePriceLists[regionId][customerGroupId] &&
      this.basePriceListCacheTimes[regionId] &&
      this.basePriceListCacheTimes[regionId][customerGroupId] &&
      this.checkDate(this.cachedBasePriceLists[regionId][customerGroupId], startDate, endDate) &&
      moment().diff(this.basePriceListCacheTimes[regionId][customerGroupId], 'seconds') < this.cacheTimeNormal
    ) {
      return Promise.resolve(this.cachedBasePriceLists[regionId][customerGroupId])
    }

    return this.storeRegions.getById(regionId)
      .then(region => {
        let customerGroupPriceListsItems = region.customerGroupPriceLists ? region.customerGroupPriceLists : []
        let currentGroupPriceListItem = customerGroupPriceListsItems
          .find(priceList => priceList.customerGroupID === customerGroupId)
        let currentGroupPriceList = currentGroupPriceListItem ? currentGroupPriceListItem.priceLists : []
        let activeBasePriceLists = currentGroupPriceList
          .filter(pricelist => pricelist.type === 'BASE_PRICE_LIST')
        let periodsPriceLists = this.filterByDate(activeBasePriceLists, startDate, endDate)

        let priceListIds = periodsPriceLists
          .map(pricelist => pricelist.priceListID)
          .filter(id => !!id)

        return this.priceLists.getByIds(priceListIds)
      })
      .then(priceLists => {
        return priceLists.reduce((result, priceList) => {
          return priceList
        }, {pricelistRules: []})
      })
      .then(priceList => {
        if (!this.cachedBasePriceLists[regionId]) {
          this.cachedBasePriceLists[regionId] = []
        }
        if (!this.basePriceListCacheTimes[regionId]) {
          this.basePriceListCacheTimes[regionId] = []
        }

        this.cachedBasePriceLists[regionId][customerGroupId] = priceList
        this.basePriceListCacheTimes[regionId][customerGroupId] = moment()
        return priceList
      })
  }

  filterByDate (dateables, startDate, endDate) {
    return dateables.filter(dateable => {
      return this.checkDate(dateable, startDate, endDate)
    })
  }

  checkDate (dateable, startDate, endDate) {
    if (dateable.startDate === '0000-00-00') {
      dateable.startDate = null
    }
    if (dateable.endDate === '0000-00-00') {
      dateable.endDate = null
    }
    if (dateable.startDate && dateable.startDate > endDate) {
      return false
    } else if (dateable.endDate && dateable.endDate < startDate) {
      return false
    } else {
      return true
    }
  }
}
export default RegionCustomerGroupPriceLists



// WEBPACK FOOTER //
// ./src/api/Service/RegionCustomerGroupPriceLists.js